import { api } from "./client";

export interface DuelRoomSummary {
  room_id: string;
  host_user_id: number;
  host_name: string;
  host_br: number;
  host_class: string;
  host_level: number;
  seconds_remaining: number;
}

export interface DuelRoomDetail {
  room_id: string;
  host_user_id: number;
  host_name: string;
  host_br: number;
  host_class: string;
  guest_user_id: number | null;
  guest_name: string | null;
  guest_br: number | null;
  status: string;
  seconds_remaining: number;
  is_host: boolean;
}

export interface DuelMeResponse {
  status: "none" | "waiting" | "started" | "expired";
  room: DuelRoomDetail | null;
  battle_id: number | null;
  opponent_name: string | null;
  info_messages: string[];
  expired_message: string | null;
}

export const duelsApi = {
  createRoom: () => api.post<{ room: DuelRoomDetail }>("/duels/rooms"),

  listRooms: () => api.get<{ rooms: DuelRoomSummary[] }>("/duels/rooms"),

  getMe: () => api.get<DuelMeResponse>("/duels/me"),

  joinRoom: (roomId: string) =>
    api.post<{ battle_id: number; opponent_name: string; info_messages: string[] }>(
      `/duels/rooms/${roomId}/join`,
    ),

  leaveRoom: (roomId: string) => api.delete<DuelMeResponse>(`/duels/rooms/${roomId}`),

  ackStarted: () => api.post<{ ok: boolean }>("/duels/ack-started"),
};
